<template>
  <div class="col-12 backgroundForm">
    <div class="alert alert-info" align="center" role="alert">
        <h4 class="alert-heading">Grafico de Ordenes de Operacion</h4>     
    </div>
    <div class="form-row d-print-none">
        <div class="form-group col-12 col-md-3 offset-md-3">
            <label for="date_init_ordop"><b>Fecha Inicio</b></label>
            <datetime v-model="date_graps.init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
        </div>
        <div class="form-group col-12 col-md-3">
            <label for="time_init_ordop"><b>Fecha Final</b></label>
            <datetime v-model="date_graps.end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Hora" title="Hora de Inicio" value-zone="America/La_Paz"></datetime>        
        </div>                        
    </div>
    
        <div class="form-row d-print-none">
            <div class="input-group mb-3 col-md-4 offset-md-4">
        
                <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_graps">
                    <option value="0">TODAS LAS CAPITANIAS</option>
                    <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
                </select>                
                <div class="input-group-append">
                    <button class="btn btn-outline-success" :disabled="animate_button" @click="mCallDtsOrdop">
                        <font-awesome-icon icon="sync-alt" :spin="animate_button"/>
                    </button>            
                </div>
            </div>            
        </div>
    <bar-chart :title="graphs1.title" :subtitle="graphs1.subtitle" :x-axis-title="graphs1.xTitle" :y-axis-title="graphs1.yTitle" :series-principal="graphs1.seriePrincipal" :series-secondary="graphs1.serieSecondary" v-if="renderComponent"></bar-chart>

    <bar-chart :title="graphs2.title" :subtitle="graphs2.subtitle" :x-axis-title="graphs2.xTitle" :y-axis-title="graphs2.yTitle" :series-principal="graphs2.seriePrincipal" :series-secondary="graphs2.serieSecondary" v-if="renderComponent2"></bar-chart>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import vue from 'vue';
const qs = require('qs');

import barChart from './BarChart';

export default {
    name:'ordop-charts',
    data(){
        return{
            ports:[],
            captain_graps:null,
            date_graps:{
                init:null,
                end:null
            },
            animate_button:false,
            graphs1:{
                seriePrincipal:[],
                serieSecondary:[],
                title:'Tipo ORDOPS',
                subtitle:null,
                xTitle:'Tipos',
                yTitle:'Cantidad'
            },
            graphs2:{
                seriePrincipal:[],
                serieSecondary:[],
                title:'Resultados ORDOP',
                subtitle:null,
                xTitle:'Tipos Resultado',
                yTitle:'Cantidad'
            },
            
            renderComponent:false,
            renderComponent2:false
        }
    },
    mounted(){
        this.mCallCaptains()
    },
    methods:{
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;
            this.renderComponent2=false;

            // If you like promises better you can
            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
                this.renderComponent2 = true;
            });
        },
        async mCallCaptains(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            
            this.date_graps.init=today.getFullYear()+'-'+mes+'-'+dia;;
            this.date_graps.end=today.getFullYear()+'-'+mes+'-'+dia;;
            // console.log(cp);
            this.captain_report_ordop=this.cDtsUser.portId;
            this.ports=cp.data;
        },
        async mCallDtsOrdop(){
            // console.log(this.captain_graps)
            if(this.date_graps.init!==null && this.date_graps.end!==null && this.captain_graps!==null){
                this.animate_button=true;
            
                try {
                    let dinit=this.date_graps.init.split('-');
                    let dend=this.date_graps.end.split('-');
                    // formateamos las fechas para que se adecuen al formato
                    if(dinit[2].includes('T')){
                        let aux_i=dinit[2].split('T');
                        this.date_graps.init=`${dinit[0]}-${dinit[1]}-${aux_i[0]}`;
                    }else{
                        this.date_graps.init=`${dinit[0]}-${dinit[1]}-${dinit[2]}`;
                    }

                    if(dend[2].includes('T')){
                        let aux_e=dend[2].split('T');
                        this.date_graps.end=`${dend[0]}-${dend[1]}-${aux_e[0]}`;
                    }else{
                        this.date_graps.end=`${dend[0]}-${dend[1]}-${dend[2]}`;
                    }
                    let p_dts;
                    if(typeof(this.captain_graps)==='object'){
                        p_dts=await axios.get(`getOrdopsDate/${this.captain_graps.id}/${this.date_graps.init}/${this.date_graps.end}?api_token=${Vue.auth.getToken()}`);
                    }else{
                        p_dts=await axios.get(`getOrdopsDate/0/${this.date_graps.init}/${this.date_graps.end}?api_token=${Vue.auth.getToken()}`);                        
                    }                    

                    this.graphs1.seriePrincipal=[];
                    this.graphs1.serieSecondary=[];

                    this.graphs2.seriePrincipal=[];
                    this.graphs2.serieSecondary=[];

                    let init_1=p_dts.data.init;
                    let process = p_dts.data.process;
                    let charge = p_dts.data.charge;

                    
                    console.log(p_dts);
                    // la primera serie del cuadro
                    init_1.forEach(e => {
                        let aux_init={
                            // {name: "Datos", y: 0, drilldown: "id_submenu"}
                            name:e.tipo_inicio,
                            y:parseInt(e.cantidad)
                        }
                        this.graphs1.seriePrincipal.push(aux_init);
                    });
                    // console.log(this.graphs1.seriePrincipal);
                    // la segunda serie con dos niveles de los resultados
                    // aca es el registro de ordops resultado(principal)
                    process.forEach(e=>{
                        let aux_init={
                            name:e.tipo_resultado,
                            y:parseInt(e.cantidad),
                            drilldown:e.code
                        }
                        this.graphs2.seriePrincipal.push(aux_init);
                    });
                    // aca recorremos la carga para segundo y tercer nivel respectivamente
                    charge.forEach(e=>{
                        let aux_init={
                            id:e.code,
                            data:[]
                        }
                        let aux_second={name:null, y:0, drilldown:null};
                        let aux_tirdth={};
                        
                        // verificar si tiene cantidad
                        // guardamos el resultado dos veces iteramos.
                        let aux_result=e.results;
                        // creamos un array que guarde los codigos y verifique que no son anadidos mas de dos veces
                        let array_codes=[];                            
                        // este almacena de acuerdo al codigo del anterior la cantidad y tipo de carga
                        let array_charges=[];

                        let ctrl_charge=false;

                        aux_result.forEach((es, index)=>{
                            
                            // console.log(`${es.carga} y ${e.code} / ${es.codigo_carga}`);
                            // console.log(array_codes.length);
                            if(array_codes.length===0){
                                // si es cero anadimos el primer elemento
                                let aux_load={
                                    name:es.carga,
                                    y:1,
                                    drilldown:parseInt(`${e.code}${es.codigo_carga}`)    
                                }
                                array_codes.push(aux_load);                                
                                // aqui anadimos su primera carga ya sea kilo , cantidad y tipo
                                ctrl_charge=true;

                            }else{
                                // verificamos que el codigo no se encuentre registrado
                                let aux_code_array=parseInt(`${e.code}${es.codigo_carga}`);
                                let vidx=array_codes.findIndex(cod => cod.drilldown === aux_code_array);
                                // console.log(`se encontro el codigo ${vidx}`)
                                if(vidx < 0){
                                    // significa que no encontro el codigo y lo registra
                                    let aux_load={
                                        name:es.carga,
                                        y:1,
                                        drilldown:parseInt(`${e.code}${es.codigo_carga}`)    
                                    }
                                    array_codes.push(aux_load);
                                    ctrl_charge=true;
                                }else{
                                    // console.log(`encontro el codigo`);
                                    array_codes[vidx].y+=1;
                                    ctrl_charge=false;
                                }

                                // verificamos si la carga fue registrada
                            }

                            if(ctrl_charge){
                                // agregamos por primera vez la carga si es falso significa que debemos buscar
                                let charge_aux;
                                if(es.cantidad>0){
                                    // si es mayor a cero significa que es cantidad
                                    let name_quantity=es.tipo_carga>0 ? es.tipo_carga_detalle:'CANTIDAD';
                                    charge_aux={
                                        id:parseInt(`${e.code}${es.codigo_carga}`),
                                        data:[
                                            {name:name_quantity, y:parseInt(es.cantidad)}
                                        ]
                                    }
                                    array_charges.push(charge_aux);
                                }
                                if(es.kilo>0){
                                    charge_aux={
                                        id:parseInt(`${e.code}${es.codigo_carga}`),
                                        data:[
                                            {name:'KILO', y:parseInt(es.kilo)}
                                        ]
                                    };
                                    array_charges.push(charge_aux);
                                }
                                if(es.litros>0){
                                    charge_aux={
                                        id:parseInt(`${e.code}${es.codigo_carga}`),
                                        data:[
                                            {name:'LITRO', y:parseInt(es.litros)}
                                        ]
                                    };
                                    array_charges.push(charge_aux);
                                }
                                if(es.mujer>0 || es.nino>0 || es.varon>0 || es.nina>0){
                                    // cualquiera seria una persona
                                    charge_aux={
                                        id:parseInt(`${e.code}${es.codigo_carga}`),
                                        data:[
                                            {name:'VARON', y:parseInt(es.varon)},
                                            {name:'MUJER', y:parseInt(es.mujer)},
                                            {name:'NIÑO', y:parseInt(es.nino)},
                                            {name:'NIÑA', y:parseInt(es.nina)}
                                        ]
                                    };
                                    array_charges.push(charge_aux);
                                }
                            }else{
                                // se debe buscar si el codigo ya existe
                                let cod_aux=parseInt(`${e.code}${es.codigo_carga}`)
                                let indice_charge=array_charges.findIndex(ch => ch.id === cod_aux);
                                let charge_aux;

                                let aux_name;
                                if(es.cantidad>0){                                    
                                    let name_quantity=es.tipo_carga>0 ? es.tipo_carga_detalle:'CANTIDAD';
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name === name_quantity);
                                    
                                    if(index_quantity<0){
                                        
                                        array_charges[indice_charge].data.push({name:name_quantity, y:parseInt(es.cantidad)})
                                    }else{
                                        // anadimos al indice existente
                                        array_charges[indice_charge].data[index_quantity].y+=es.cantidad;
                                    }
                                    // continuar con la verificacion de las cantidades aqui al verificar es sumar o agregar                                    
                                }
                                if(es.kilo>0){
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='KILO');
                                    array_charges[indice_charge].data[index_quantity].y+=es.kilo;
                                }
                                if(es.litros>0){
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='LITROS');
                                    array_charges[indice_charge].data[index_quantity].y+=es.litros;                                    
                                }
                                if(es.varon>0){
                                    // cualquiera seria una persona
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='VARON');
                                    array_charges[indice_charge].data[index_quantity].y+=es.varon;
                                }
                                if(es.mujer>0){
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='MUJER');
                                    array_charges[indice_charge].data[index_quantity].y+=es.mujer;
                                }
                                if(es.nino>0){
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='NIÑO');
                                    array_charges[indice_charge].data[index_quantity].y+=es.nino;
                                }
                                if(es.nina>0){
                                    let index_quantity=array_charges[indice_charge].data.findIndex(tc=> tc.name==='NIÑA');
                                    array_charges[indice_charge].data[index_quantity].y+=es.nina;
                                }

                            }
                            
                            // let arm={
                            //     name:es.carga,
                            //     y:parseInt(es.cantidad_carga),
                            //     drilldown:parseInt(`${e.code}${es.codigo_carga}`)
                            // }
                            
                        }) //fin del primer bucle de datos
                        // una vez finalizado el bucle de datos recien anadir
                        array_codes.forEach(ac=>{
                            aux_init.data.push(ac)
                        });
                        this.graphs2.serieSecondary.push(aux_init);
                        // console.log(array_charges);
                        array_charges.forEach(cc=>{
                            this.graphs2.serieSecondary.push(cc);
                        })
                        
                        
                    })
                    
                    setTimeout(() => {
                        this.animate_button=false;
                    }, 2000);
                    
                } catch (error) {
                    console.log(error);
                    setTimeout(() => {
                        this.animate_button=false;
                    }, 2000);
                }
                let subtitle_aux=`${this.mConvertDate(this.date_graps.init)} al ${this.mConvertDate(this.date_graps.end)}`;
                
                if( typeof(this.captain_graps) ==='object'){
                    this.graphs1.title=`ORDOP INICIO <br>${this.captain_graps.name_port}`;
                    this.graphs2.title=`ORDOP RESULTADOS <br>${this.captain_graps.name_port}`;              
                }else{
                    this.graphs1.title='TODAS LAS CAPITANIAS';
                    this.graphs2.title='TODAS LAS CAPITANIAS';
                }
                
                this.graphs1.subtitle=subtitle_aux;
                this.graphs2.subtitle=subtitle_aux;
                this.forceRerender();
            }else{
                toastr.warning('Verifique que los campos esten seleccionados', 'Advertencia')
            }                
        },
        mConvertDate(d){
            let m=["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            
            let nf=d.split('-');
            
            let day_aux=0;
            
            if(nf[2].includes('T')){
                let auxd=nf[2].split('T');
                day_aux=auxd[0];
            }else{
                day_aux=nf[2];
            }
            let date_string=`${day_aux} de ${m[parseInt(nf[1])-1]} de ${nf[0]}`;
            return date_string;            
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        barChart
    }
}
// ["CANTIDAD", parseInt(es.cantidad)],
//                                     ["KILO", parseInt(es.kilo)],
//                                     ["LITROS", parseInt(es.litros)],
//                                     ["HOMBRE", parseInt(es.varon)],
//                                     ["MUJER", parseInt(es.mujer)],
//                                     ["NIÑO", parseInt(es.nino)],
//                                     ["NIÑA", parseInt(es.nina)]
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/charts/OrdopCharts.vue